import { ADMIN_STATE_KEY } from "~/admin";
import { SYSTEM_DATA_KEY } from "./reducer";

const _getModuleState = (state) => state[ADMIN_STATE_KEY][SYSTEM_DATA_KEY];

export const getSystemSettings = (state) => _getModuleState(state).systemSettings;
